export function fidelityLabelOf(svgState) {
    if (svgState === 'hidden' || svgState === 'done') {
        return null;
    }
    return svgState === 'lossy' ? 'Low Fidelity' : 'Transient Low Fidelity';
}
